import { AssemblySplitModeSchema, AssemblySplitModeType } from "../generated/prisma/zod";

export const resolveAssemblySplitMode = (
  companyAssemblySplitMode: AssemblySplitModeType | null | undefined,
): AssemblySplitModeType => {
  if (companyAssemblySplitMode === AssemblySplitModeSchema.enum.ALL) {
    return AssemblySplitModeSchema.enum.LEAF;
  }
  return companyAssemblySplitMode ?? AssemblySplitModeSchema.enum.LEAF;
};
